
$(document).ready(function(){
    const url_params = new URLSearchParams(window.location.search);
    var order_id = url_params.get('id');
    var token = url_params.get('token');
    var removedShoes = {};
    var data = {
            id: order_id,
            action: 'single_order'
        };

    $.post(`${tracking_url}/storeFrontCalls.php`,
        JSON.stringify(data),
        function (orders_object) { 
            let orderRefund = '';
            let formatedOrder = '';
			if (token != orders_object.token) { alert('invalid token'); return };
			const updateModul = UpdateModule($);
			
            fillPosRemovedShoesList(removedShoes,orders_object);
            orderRefund = getOrderRefundObject(orders_object);
            formatedOrder = formatShopifyOrder(orders_object, orderRefund, removedShoes[orders_object.name]);
			if(orders_object.tags.indexOf('Order Returned') !== -1){
				alert('your order was canceled')
				return;
            }
			if(orders_object.tags.indexOf('Order Updated') !== -1){
				updateModul.afterUpdate(formatedOrder);
				return;
            }
            updateModul.init(formatedOrder);
        }, 
        'json'
    );
});

  function getOrderRefundObject(shopifyOrder){
    let refunds = shopifyOrder.refunds;
    let total_refunded_price = 0;
    let refunded_items_ids = []
    if (refunds.length > 0) {
      for (ref in refunds) {
        for (item in refunds[ref].refund_line_items) {
          refunded_items_ids.push(refunds[ref].refund_line_items[item].line_item_id);
          total_refunded_price += parseFloat(refunds[ref].refund_line_items[item].subtotal);
        }
      }
    }
    return {
      total_refunded_price: total_refunded_price,
      refunded_items_ids: refunded_items_ids
    }
  }

function formatShopifyOrder(originalOrder, orderRefundObject, removedShoes) 
{
	var total_line_items_price = 0,
	total_price = 0,
	formatedOrder = {},
	source = originalOrder.source_name;
	var shopifyOrder = JSON.parse(JSON.stringify(originalOrder));
	total_line_items_price = parseFloat(shopifyOrder.total_line_items_price) - orderRefundObject.total_refunded_price;
	total_price = parseFloat(shopifyOrder.total_price) - orderRefundObject.total_refunded_price;
	formatedOrder = {
		items: [],
		attributes: {
			total_line_items_price: Math.abs(total_line_items_price).toFixed(2),
			total_price: Math.abs(total_price).toFixed(2),
			subtotal_price: Math.abs(parseFloat(shopifyOrder.subtotal_price)).toFixed(2),
			total_tax: Math.abs(shopifyOrder.total_tax).toFixed(2),
			total_discounts: Math.abs(shopifyOrder.total_discounts).toFixed(2),
		},
		note_attributes: shopifyOrder.note_attributes,
		tags: shopifyOrder.tags.split(','),
		admin_graphql_api_id: shopifyOrder.admin_graphql_api_id,
		order_id: shopifyOrder.id,
		name: shopifyOrder.name,
		total_price: total_price,
		paid: false,
		payment_needed: false,
	};

	if(shopifyOrder.tags.indexOf('Payment Needed') !== -1){ 
		formatedOrder.payment_needed = true;
	}
	if(shopifyOrder.tags.indexOf('Order paid') !== -1){
		formatedOrder.paid = true;
	}

	if(source == 'pos' || shopifyOrder.cart_token == '' || shopifyOrder.cart_token == null){
		source = 'pos'
	}

	if (source == 'pos') {
		duplicatePosOrderItems(shopifyOrder, removedShoes);
	}; 

	// line items
	for (item in shopifyOrder.line_items) {
		let lineItem = shopifyOrder.line_items[item];
		lineItem['source'] = source;
		if (lineItem.product_id) {
			if (
				((jQuery.inArray(lineItem.id, orderRefundObject.refunded_items_ids) == -1) && (source != 'pos')) || 
				((lineItem.quantity == 1) && (source == 'pos'))
			) {
				
				if (source != 'pos'){

					if (lineItem.properties.length >= 2) {
						let newProperties = {};
						for (prop in lineItem.properties) {
							newProperties[lineItem.properties[prop].name.trim()] = lineItem.properties[prop].value;
							if (lineItem.properties[prop].name.trim() == 'Product_number') {
								newProperties['Shoes_number'] = '';
								newProperties['Shoes_number'] = lineItem.properties[prop].value;
							}
						}
						lineItem.properties = newProperties;
					}
					if (lineItem.properties.length == 1 ) {
						lineItem.properties = {
							Type: 'Accessory'
						};
					}
				}else{
					lineItem['source'] = 'pos';
					let collectionKey = lineItem.sku.split('-');
					let collection = '';
					if(CollectionsObject.collections[collectionKey[0]] != undefined){
						collection = CollectionsObject.collections[collectionKey[0]].name;
					}
					let newProperties = {};
					for (prop in lineItem.properties) {
						newProperties[lineItem.properties[prop].name.trim()] = lineItem.properties[prop].value;
						if ((lineItem.properties[prop].name.trim() == 'Shoes_number') || (lineItem.properties[prop].name.trim() == 'Product_number')){
							newProperties['Collection_number'] = '';
							newProperties['Collection_number'] = lineItem.properties[prop].value;
						}

						if (lineItem.properties[prop].name.trim() == 'Product_number') {
							newProperties['Shoes_number'] = '';
							newProperties['Shoes_number'] = lineItem.properties[prop].value;
						}
					}
					lineItem.properties = {
						...newProperties,
						Collection: collection,
						Type: 'Collection'
					}
					
				}
				formatedOrder.items.push(lineItem);
			}
		} else {
			var properties = lineItem.name.split(';');
			lineItem.properties = {};
			for (tab in properties) {
				if (properties[tab].split(':')[0] == 'Product_number') {
					lineItem.properties['Shoes_number'] = properties[tab].split(':')[1];
				}
				lineItem.properties[properties[tab].split(':')[0]] = properties[tab].split(':')[1];
			}
			lineItem['title'] = properties[0].split(':')[1];
			formatedOrder.items.push(lineItem);
		}
	}

	// note attribute
	for (k in shopifyOrder.note_attributes) {
		let att = shopifyOrder.note_attributes[k];
		formatedOrder.attributes[att.name] = att.value;
	}

	return formatedOrder;
}

function duplicatePosOrderItems(shopifyOrder, removedShoesList)
{
	for (item in shopifyOrder.line_items) { 
		let shoesArray = getItemShoeNumbers(shopifyOrder.line_items[item]);
		if (removedShoesList[shopifyOrder.line_items[item].id] == undefined) {
			if(shoesArray.length > 1){
				let newItem = JSON.parse(JSON.stringify(shopifyOrder.line_items[item]));
				let quantity = newItem.quantity;
				shopifyOrder.line_items[item].quantity = 1;
				for( prop in shopifyOrder.line_items[item].properties) {
					if ((shopifyOrder.line_items[item].properties[prop].name.trim() == 'Shoes_number') || (shopifyOrder.line_items[item].properties[prop].name.trim() == 'Product_number')){
						shopifyOrder.line_items[item].properties[prop].value = shoesArray[0];
					}
				}
				for (let index = 1; index < quantity; index++) {
					let newItem = JSON.parse(JSON.stringify(shopifyOrder.line_items[item]));
					for( prop in newItem.properties) {
						if ((newItem.properties[prop].name.trim() == 'Shoes_number') || (newItem.properties[prop].name.trim() == 'Product_number')){
							newItem.properties[prop].value = shoesArray[index];
						}
					} 
					shopifyOrder.line_items.push(newItem);
				}
			}
		} else {
			if (removedShoesList[shopifyOrder.line_items[item].id].length >= shoesArray.length) {
				shopifyOrder.line_items[item].quantity = 0;
			} else {
				let itemUpdated = false;
				shopifyOrder.line_items[item].quantity = 1;
				for (shoe in shoesArray) {
					if (jQuery.inArray('shoe_removed_'+shoesArray[shoe], removedShoesList[shopifyOrder.line_items[item].id]) == -1) {
						if (!itemUpdated) {
							for( prop in shopifyOrder.line_items[item].properties) {
								if ((shopifyOrder.line_items[item].properties[prop].name.trim() == 'Shoes_number') || (shopifyOrder.line_items[item].properties[prop].name.trim() == 'Product_number')){
									shopifyOrder.line_items[item].properties[prop].value = shoesArray[shoe];
									itemUpdated = true;
								}
							}
						} else {
							let newItem = JSON.parse(JSON.stringify(shopifyOrder.line_items[item]));
							for( prop in newItem.properties) {
								if ((newItem.properties[prop].name.trim() == 'Shoes_number') || (newItem.properties[prop].name.trim() == 'Product_number')){
									newItem.properties[prop].value = shoesArray[shoe];
								}
							}
							shopifyOrder.line_items.push(newItem);
						}
					}
				}

			}
		}
	}
	
}

function getItemShoeNumbers(PosItem)
{
	let shoeArray = [],
	property = '';
	for( prop in PosItem.properties) {
		if ((PosItem.properties[prop].name.trim() == 'Shoes_number') || (PosItem.properties[prop].name.trim() == 'Product_number')){
			property = PosItem.properties[prop].value;
		}
	}
	if(property){
		shoeArray = property.replace(/([~!@#$%^&*()+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '-').split('-');
		if (shoeArray.length > PosItem.quantity) {
			let diff = shoeArray.length - PosItem.quantity;
			for (let index = 1; index <= diff; index++) {
				shoeArray.pop();
			}
		}
	} 
	return shoeArray;
}

function fillPosRemovedShoesList(removedShoesList,shopifyOrder) 
{
	removedShoesList[shopifyOrder.name] = {}
	for (attr in shopifyOrder.note_attributes) {
		if (shopifyOrder.note_attributes[attr].name.indexOf('shoe_removed') != -1) {
			if	(removedShoesList[shopifyOrder.name][shopifyOrder.note_attributes[attr].value] == undefined) {
				removedShoesList[shopifyOrder.name][shopifyOrder.note_attributes[attr].value] = [];
			}
			removedShoesList[shopifyOrder.name][shopifyOrder.note_attributes[attr].value].push(shopifyOrder.note_attributes[attr].name);
		}
	} 
}

window.updateModule = window.UpdateModule || {};
window.UpdateModule = function($){
	let order_to_update = {};
	let original_order;
	let shoes_settings = {};
	let $ass_popup = null;
	let current_order_id = '';
	let $open_popup_btn = null;
	this.noImageSrc = 'https://cdn.shopify.com/s/files/1/0314/2300/4803/files/cleaning.jpg?v=1622815757';
	this.mandatoryIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
		<path d="M9 1C4.58214 1 1 4.58214 1 9C1 13.4179 4.58214 17 9 17C13.4179 17 17 13.4179 17 9C17 4.58214 13.4179 1 9 1ZM9 15.6429C5.33214 15.6429 2.35714 12.6679 2.35714 9C2.35714 5.33214 5.33214 2.35714 9 2.35714C12.6679 2.35714 15.6429 5.33214 15.6429 9C15.6429 12.6679 12.6679 15.6429 9 15.6429Z" fill="#636363" stroke="#636363" stroke-width="0.5"/>
		<path d="M8 5.85714C8 6.08447 8.10536 6.30249 8.29289 6.46323C8.48043 6.62398 8.73478 6.71429 9 6.71429C9.26522 6.71429 9.51957 6.62398 9.70711 6.46323C9.89464 6.30249 10 6.08447 10 5.85714C10 5.62981 9.89464 5.4118 9.70711 5.25105C9.51957 5.09031 9.26522 5 9 5C8.73478 5 8.48043 5.09031 8.29289 5.25105C8.10536 5.4118 8 5.62981 8 5.85714ZM9.5 7.85714H8.5C8.40833 7.85714 8.33333 7.92143 8.33333 8V12.8571C8.33333 12.9357 8.40833 13 8.5 13H9.5C9.59167 13 9.66667 12.9357 9.66667 12.8571V8C9.66667 7.92143 9.59167 7.85714 9.5 7.85714Z" fill="#636363" stroke="#636363" stroke-width="0.5"/>
		</svg>`;
	this.trashIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
		<path d="M13.75 1.66687H8.25C7.23892 1.66687 6.41667 2.41437 6.41667 3.33354V5.0002H2.75V6.66687H4.58333V16.6669C4.58333 17.586 5.40558 18.3335 6.41667 18.3335H15.5833C16.5944 18.3335 17.4167 17.586 17.4167 16.6669V6.66687H19.25V5.0002H15.5833V3.33354C15.5833 2.41437 14.7611 1.66687 13.75 1.66687ZM8.25 3.33354H13.75V5.0002H8.25V3.33354ZM15.5833 16.6669H6.41667V6.66687H15.5833V16.6669Z" fill="#636363"/>
		</svg>`;
	this.toggle = `<label class="action decline switch">
			<input name="decline-shoe" type="checkbox" checked>
			<span class="slider round"></span>
			</label>`;
	function init (order){
		formatOrder(order);
		$open_popup_btn = $(`#process-assessment`);
        $ass_popup = $(`.assessment-content`) ;
		current_order_id = order.order_id;
		original_order = order;
		drawOrderUpdates();
	}
	function formatOrder(order){
        order.items.forEach(item => {
            if(item.product_id && item.sku){
                let shoe_number = item.properties.Shoes_number;
                let collectionKey = item.sku.split('-');
                let shoe = `shoe_${shoe_number}`;
                if(!order_to_update.hasOwnProperty(shoe)){
                    order_to_update[shoe] = {
                        need_assessment:false,
                        is_hassle_free:false,
                        collection: CollectionsObject.collections[collectionKey[0]].name,
                        image : CollectionsObject.collections[collectionKey[0]].image,
                        name : '',
						video:'',
						order:order.name,
                        items:[],
                        source: item.source,
                        number:shoe_number,
                        attributes: {
                            remove:'',
                            add:''
                        },
                    }
                }
                order_to_update[shoe].items.push(item); 
                
                if(item.title.toLowerCase().indexOf('hassle free') !== -1){
                    order_to_update[shoe].is_hassle_free = true;
                }
                if(order.attributes.hasOwnProperty(`shoe_add_assessment_${shoe_number}`)){
                    order_to_update[shoe].attributes['add'] = order.attributes[`shoe_add_assessment_${shoe_number}`];
                    order_to_update[shoe].need_assessment = true
                }
                if(order.attributes.hasOwnProperty(`shoe_remove_assessment_${shoe_number}`)){
                    order_to_update[shoe].attributes['remove'] = order.attributes[`shoe_remove_assessment_${shoe_number}`];
                    order_to_update[shoe].need_assessment = true
                }
                if(order.attributes.hasOwnProperty(`shoe_picture_in_1_url_${shoe_number}`)){
                    order_to_update[shoe].image = order.attributes[`shoe_picture_in_1_url_${shoe_number}`];
                }
				if(order.attributes.hasOwnProperty(`customerproduct_assessment_video_${shoe_number}`)){
					order_to_update[shoe].video = order.attributes[`customerproduct_assessment_video_${shoe_number}`];
				}
				if(order.attributes.hasOwnProperty(`brand_product_${shoe_number}`)){
					order_to_update[shoe].name = `<span>${order.attributes[`brand_product_${shoe_number}`]}</span> ${order.attributes[`color_product_${shoe_number}`]} size: ${order.attributes[`size_product_${shoe_number}`]}`;
				}
            }
		})
        return order_to_update;
	}

	function drawOrderUpdates(){
		processOrderUpdate();
	}

	function setOrderSettings(order){
		// order_to_update = JSON.parse(JSON.stringify(orders[order_name]));
		$ass_popup = $(`.assessment-content`) ;
		current_order_id = order.id;
		shoes_settings = {};
	}

	async function processOrderUpdate() {
		drawShoeSceleton();
		await setAllShoeSettings();
		drawUpdatePopup();
	}

	async function drawShoeSceleton() {
		for (shoe in order_to_update) {
			if (!order_to_update[shoe].need_assessment) continue;
			let shoe_wrapper = $('<div />');
			shoe_wrapper.addClass(`shoe-update-content ${shoe}`);
			shoe_wrapper = await drawShoeImageHtml(shoe_wrapper, shoe);
			shoe_wrapper.append(`<div class="update-items"><h3 class="product_title">${order_to_update[shoe].name}</h3></div>`);
			shoe_wrapper.find('.update-items')
			.append(`<div class="update-inner skeleton">
				<div class="skeleton__one-line" style="margin:10px"></div>
				<div class="skeleton__one-line" style="margin:10px"></div>
				<div class="skeleton__one-line" style="margin:10px"></div>
			</div>`);
			$ass_popup.find('form .orders_items').append(shoe_wrapper);
		}

		$ass_popup.find('.placeholder-spin').addClass('hide');
		$ass_popup.find('form').removeClass('hide');
	}

	async function setAllShoeSettings() {
		for(sh in order_to_update){
			let shoe = order_to_update[sh];
			if(shoe.need_assessment) await setShoeSettings(shoe);
		}
		return new Promise((resolve, reject) => {
			resolve();
		})
	}

	async function setShoeSettings(obj){
		await setShoeItemsSettings(obj.attributes.add, obj, 'add');
		await setShoeItemsSettings(obj.attributes.remove, obj, 'remove');
		await setRemainingItem(obj.items, obj);
		return new Promise((resolve, reject) => {
			resolve();
		}) 
	}

	async function drawUpdatePopup(){
		for (const shoe in shoes_settings) {
			let shoe_wrapper = $(`.shoe-update-content.${shoe}`);
			shoe_wrapper.find('.update-inner.skeleton').remove();
			// let shoe_wrapper = $('<div />');
			// shoe_wrapper.addClass(`shoe-update-content ${shoe}`);
			// shoe_wrapper = await drawShoeImageHtml(shoe_wrapper, shoe);
			// shoe_wrapper.append(`<div class="update-items"><h3 class="product_title">${order_to_update[shoe].name}</h3></div>`);
			if(!$.isEmptyObject(shoes_settings[shoe].item)) shoe_wrapper = await drawShoeItemHtml(shoe_wrapper, shoes_settings[shoe].item, shoe);
			shoe_wrapper.find('.update-items').append(`<h3 class="title">Updates:</h3>`);
			if(!$.isEmptyObject(shoes_settings[shoe].remove)) shoe_wrapper = await drawShoeRemoveHtml(shoe_wrapper,shoes_settings[shoe].remove, shoe);
			if(!$.isEmptyObject(shoes_settings[shoe].add)) shoe_wrapper = await drawShoeAddHtml(shoe_wrapper,shoes_settings[shoe].add, shoe);
			shoe_wrapper.find('.update-items').append(
				`<div class="refund-shoe__wrapper">
					<div class="refund-shoe">
						<input type="checkbox" name="refund-shoe" data-shoe="${shoe}">
						<label>I don’t approve. Return this product</label>
					</div>
				</div>`
			);
			// $ass_popup.find('form .orders_items').append(shoe_wrapper);
		}
		$ass_popup.find('form').append(`<input type="hidden" name="discounts" value="${original_order.attributes.total_discounts}">`);
		$ass_popup.find('form').append(`<input type="hidden" name="totals" value="${original_order.attributes.subtotal_price}">`);
		calculateTotals();
		setupEvents();
		// $ass_popup.find('.placeholder-spin').addClass('hide');
		// $ass_popup.find('form').removeClass('hide');
		// $open_popup_btn.addClass('loaded');
		// $open_popup_btn.find('.spin').addClass('hide');
		// $ass_popup.find('.popup_wrapper').show();
	}

	/**
	 * ================
	 * GROUP SHOE SETTINGS WITH THE VARIANT DATA
	 * ================
	*/

	async function setShoeItemsSettings(attribute, obj, type){
		if(attribute){
			let handle = 'shoe_'+ obj.number;
			let att_array = attribute.split(',');
			if(!shoes_settings.hasOwnProperty(handle)) shoes_settings[handle] = {add:{},remove:{},item:{}}
			for (const item of att_array) {
				item_array = item.split('|');
				shoes_settings[handle][type][item_array[0]] = {variant_id: item_array[0]};
				await fillShoeSetting(item_array, obj, handle, type);
			}
			return new Promise((resolve, reject) => {
				resolve();
			}) 
		};
	}

	async function setRemainingItem(items, obj){
		let handle = 'shoe_'+ obj.number;
		if(!shoes_settings.hasOwnProperty(handle)) shoes_settings[handle] = {add:{},remove:{},item:{}};
		for (const item of items) {
			let variant = await fetchVariant(item.variant_id);
			shoes_settings[handle].item[item.variant_id] = {};
			shoes_settings[handle].item[item.variant_id]['product_name'] = variant.product.title;
			shoes_settings[handle].item[item.variant_id]['title'] = variant.title;
			shoes_settings[handle].item[item.variant_id]['collection'] = obj.collection;
			shoes_settings[handle].item[item.variant_id]['options'] = variant.selectedOptions;
			shoes_settings[handle].item[item.variant_id]['product_number'] = obj.number;
			shoes_settings[handle].item[item.variant_id]['price'] = variant.price;
			shoes_settings[handle].item[item.variant_id]['line_item_id'] = item.id;
			shoes_settings[handle].item[item.variant_id]['variant_id'] = item.variant_id;
			shoes_settings[handle].item[item.variant_id]['image'] = variant.image ? variant.image.originalSrc : this.noImageSrc;
		}
		return new Promise((resolve, reject) => {
			resolve();
		}) 
	}

	async function fillShoeSetting(item_array, shoe, shoe_handle, type){
		let variant = await fetchVariant(item_array[0]);
		shoes_settings[shoe_handle][type][item_array[0]]['product_name'] = variant.product.title;
		shoes_settings[shoe_handle][type][item_array[0]]['title'] = variant.title;
		shoes_settings[shoe_handle][type][item_array[0]]['collection'] = shoe.collection;
		shoes_settings[shoe_handle][type][item_array[0]]['options'] = variant.selectedOptions;
		shoes_settings[shoe_handle][type][item_array[0]]['product_number'] = shoe.number;
		shoes_settings[shoe_handle][type][item_array[0]]['price'] = item_array[1] ? Math.abs(parseFloat(item_array[1])).toFixed(2) : variant.price;
		shoes_settings[shoe_handle][type][item_array[0]]['line_item_id'] = '';
		shoes_settings[shoe_handle][type][item_array[0]]['type'] = "Collection"; 
		shoes_settings[shoe_handle][type][item_array[0]]['mandatory'] = (item_array[2] || (!item_array[2] && !item_array[3])) ? 'M' : '';
		shoes_settings[shoe_handle][type][item_array[0]]['odoo'] = item_array[3] ? item_array[3] : '';
		shoes_settings[shoe_handle][type][item_array[0]]['image'] = variant.image ? variant.image.originalSrc : variant.product.images.edges.length > 0 ? variant.product.images.edges[0].node.originalSrc : this.noImageSrc;
		for (let item of order_to_update[shoe_handle].items) {
			if(item.variant_id.toString() == item_array[0]){
				if(type == 'remove'){
					shoes_settings[shoe_handle][type][item_array[0]]['line_item_id'] = item.id;
					break;
				}
			}
		}
		return new Promise((resolve, reject) => {
			resolve();
		}) 
	}

	/**
	 * ================
	 * FETCHING VARIANT DATA
	 * ================
	*/

	function fetchVariant(variant_id) {

		return new Promise((resolve, reject) => {
			let data = {
				id: variant_id,
				action: 'variant'
			};
			$.post(`${tracking_url}/storeFrontCalls.php`,
				JSON.stringify(data),
				function (resp) {
					let variant = resp.response.data.productVariant;
					resolve(variant);
				},
				'json'
			).fail(function (error) {
				reject(`failed to load variant ${variant_id}`)
			});
		})
	}
	function fetchMetafields(order_id) {

		return new Promise((resolve, reject) => {
			let data = {
				id: order_id,
				action: 'get_order_meta'
			};
			$.post(`${tracking_url}/storeFrontCalls.php`,
				JSON.stringify(data),
				function (resp) {
					resolve(resp);
				},
				'json'
			).fail(function (error) {
				reject(`failed to load variant ${variant_id}`)
			});
		})
	}

	/**
	 * ================
	 * CREATING HTML ELEMENTS FOR THE UPDATE ELEMENT
	 * ================
	*/

	function drawShoeImageHtml(shoe_wrapper, shoe){
		const image_container = $('<div />').addClass('image-wrapper');
		if(order_to_update[shoe].video){
			image_container.append(
				`
				<video width="100%" height="100%" controls preload="auto">
					<source src="${order_to_update[shoe].video}#t=0.7" type="video/mp4">
				</video>
				`
			);
			shoe_wrapper.append(image_container);
			shoe_wrapper.find('.image-wrapper').before(`<h3 class="product_title">${order_to_update[shoe].name}</h3>`);
			return new Promise((resolve, reject) => {
				resolve(shoe_wrapper);
			})
		}
		const image = $('<img />');
		image.attr('src', order_to_update[shoe].image);
		image_container.append(image);
		shoe_wrapper.append(image_container);
		shoe_wrapper.find('.image-wrapper').before(`<h3 class="product_title">${order_to_update[shoe].name}</h3>`);
		return new Promise((resolve, reject) => {
			resolve(shoe_wrapper);
		})
	}
	function drawShoeItemHtml(shoe_wrapper, shoe_items, shoe){
		const update_content = $('<div />'); 
		update_content.addClass('update-inner shoe-items'); 
		update_content.append(`<h3 class="title">Your Original Order ${order_to_update[shoe].order}</h3>`);
		if(!order_to_update[shoe].is_hassle_free){
		}
		for(item in shoe_items){
			const service_item = $('<div />')
			service_item.addClass('service_item shoe-items not-calculate');
			if(!order_to_update[shoe].is_hassle_free){
				service_item.append(
					`<span class="title">
						<span>${shoe_items[item].product_name}</span>
						<span class="subtitle">${shoe_items[item].options.length > 1 ? shoe_items[item].title : ''} - </span>
						<span class="item-price item-price__plus">$${shoe_items[item].price}</span>
					</span>
					`
				);
			}
			service_item.append(
				`	<input type="hidden" name="id" value="${shoe_items[item].variant_id} "/>
					<input type="hidden" name="line_item_id" value= "${shoe_items[item].line_item_id}"/>
					<input type="hidden" name="price" value="${shoe_items[item].price}"/>
					<input type="hidden" name="variant_title" value="${shoe_items[item].title}"/>
					<input type="hidden" name="shoes_number" value="${order_to_update[shoe].number}"/>
					<input type="hidden" name="collection" value="${order_to_update[shoe].collection}"/>
					<input type="hidden" name="collection_number" value="${order_to_update[shoe].number}"/>
					<input type="hidden" name="product_name" value="${shoe_items[item].product_name}"/>
					<input type="hidden" name="source" value="${order_to_update[shoe].source}"/>
				`
			);
			update_content.append(service_item);
		}
		shoe_wrapper.find('.update-items').append(update_content);
		return new Promise((resolve, reject) => {
			resolve(shoe_wrapper);
		})
	}
	function drawShoeAddHtml(shoe_wrapper, shoe_items, shoe){
		const update_content = $('<div />');
		update_content.addClass('update-inner add-items');
		// update_content.append(`<h3>${!order_to_update[shoe].is_hassle_free ? 'We need to Add those services' : 'Our Experienced Cobblers Recommend:'}</h3>`);
		for(item in shoe_items){
			update_content.append(
				`<div class="service_item">
					<img src="${shoe_items[item].image}">
					<div class="detail">
						<span class="title">
							<span>${shoe_items[item].product_name}</span>
							<span class="subtitle">${shoe_items[item].options.length > 1 ? shoe_items[item].title : ''}</span>
							${shoe_items[item].mandatory ? '<span class="action locked">'+this.mandatoryIcon+'</span>' : this.toggle}
						</span>
						<span class="item-price item-price__plus" data-value="${shoe_items[item].price}">+$${shoe_items[item].price}</span>
					</div>
					<input type="hidden" name="id" value="${shoe_items[item].variant_id} "/>
					<input type="hidden" name="line_item_id" value= ""/>
					<input type="hidden" name="price" value="${shoe_items[item].price}"/>
					<input type="hidden" name="variant_title" value="${shoe_items[item].title}"/>
					<input type="hidden" name="shoes_number" value="${order_to_update[shoe].number}"/>
					<input type="hidden" name="collection" value="${order_to_update[shoe].collection}"/>
					<input type="hidden" name="type" value="${shoe_items[item].type}"/>
					<input type="hidden" name="collection_number" value="${order_to_update[shoe].number}"/>
					<input type="hidden" name="product_name" value="${shoe_items[item].product_name}"/>
					<input type="hidden" name="source" value="${order_to_update[shoe].source}"/>
					<input type="hidden" name="odoo" value="${shoe_items[item].odoo}"/> 
				</div>`
			);
		}
		shoe_wrapper.find('.update-items').append(update_content);
		return new Promise((resolve, reject) => {
			resolve(shoe_wrapper);
		})
	}
	function drawShoeRemoveHtml(shoe_wrapper, shoe_items, shoe){
		const update_content = $('<div />');
		update_content.addClass('update-inner remove-items');
		if(order_to_update[shoe].is_hassle_free){
			update_content.addClass('hide');
		}
		for(item in shoe_items){
			update_content.append(
				`<div class="service_item">
					<img src="${shoe_items[item].image}">
					<div class="detail">
						<span class="title">
							<span>${shoe_items[item].product_name}</span>
							<span class="subtitle">${shoe_items[item].options.length > 1 ? shoe_items[item].title : ''}</span>
							${shoe_items[item].mandatory ? '<span class="action locked">'+this.mandatoryIcon+'</span>' : this.toggle}
						</span>
						<span class="item-price item-price__minus" data-value="${shoe_items[item].price}" >-$${shoe_items[item].price}</span>
					</div>
					<input type="hidden" name="id" value="${shoe_items[item].variant_id} "/>
					<input type="hidden" name="line_item_id" value= "${shoe_items[item].line_item_id}"/>
					<input type="hidden" name="price" value="${shoe_items[item].price}"/>
					<input type="hidden" name="variant_title" value="${shoe_items[item].title}"/>
					<input type="hidden" name="shoes_number" value="${order_to_update[shoe].number}"/>
					<input type="hidden" name="collection" value="${order_to_update[shoe].collection}"/>
					<input type="hidden" name="type" value="${shoe_items[item].type}"/>
					<input type="hidden" name="collection_number" value="${order_to_update[shoe].number}"/>
					<input type="hidden" name="product_name" value="${shoe_items[item].product_name}"/>
					<input type="hidden" name="source" value="${order_to_update[shoe].source}"/>
					<input type="hidden" name="odoo" value="${shoe_items[item].odoo}"/>
				</div>`
			);
		}
		shoe_wrapper.find('.update-items').append(update_content);
		return new Promise((resolve, reject) => {
			resolve(shoe_wrapper); 
		})
	}


	/**
	 * ================
	 * CALCULATE ASSESSMENT TOTALS
	 * ================
	*/
	function calculateTotals(){
		const popup = $(`.assessment-content`);
		const refund_label = popup.find('.total_refund span.label_refund');
		const needed_label = popup.find('.total_refund span.label_paid');
		const refund_all = popup.find('.total_refund span.label_refund_all');
		const value_label = popup.find('.total_refund span.value');
		const pay_notice = popup.find('.refund_notice');
		let total_add = 0;
		let total_remove = 0;
		let order_discount = parseFloat(popup.find('form [name=discounts]').val());
		let order_total = parseFloat(popup.find('form [name=totals]').val());
		refund_label.addClass('hide');
		refund_all.addClass('hide'); 
		needed_label.addClass('hide');
		pay_notice.addClass('hide');

		popup.find('.remove-items .service_item:not(.not-calculate) input[name="price"],.shoe-items .service_item:not(.not-calculate) input[name="price"]').each(function(){
			total_remove += parseFloat($(this).val());
		})
		popup.find('.add-items .service_item:not(.not-calculate) input[name="price"]').each(function(){
			total_add += parseFloat($(this).val());
		})

		if (order_total < total_remove) total_remove = 0;

		if(total_add > 0 || (total_add == total_remove && total_remove == 0)){
			needed_label.removeClass('hide');
			value_label.html(`$${Math.abs(total_add).toFixed(2)}`);
		}
		if(total_remove > 0){
			pay_notice.find('.refunds').html(`$${Math.abs(total_remove).toFixed(2)}`);
			pay_notice.find('.payment').html(`$${Math.abs(total_add).toFixed(2)}`);
			pay_notice.removeClass('hide');
		}
		if(total_remove > 0 && total_add==0){
			refund_all.removeClass('hide');
			value_label.html(`$${Math.abs(total_remove).toFixed(2)}`);
		}
	}


	/**
	 * ================
	 * INIT EVENT LISTENERS
	 * ================
	*/
	function setupEvents(){
		// $ass_popup.find('.service_item span.decline').on('click', function(){handleDeclineBtnClick($(this))});
		$ass_popup.find('.service_item span.locked').on('click', function(){handleMandatoryBtnClick()});
		$ass_popup.find('input[name="refund-shoe"]').on('change', function(e){handleShoeRefund($(this), $ass_popup)});
		$ass_popup.find('input[name="decline-shoe"]').on('change', function(e){handleShoeDecline($(this), $ass_popup)});
		$ass_popup.find('.button_approve_and_update').on('click', function(e){handlePopupSubmit(e, $(this), $ass_popup)});
        $ass_popup.on('click', function(e){
            if($(e.target).hasClass('popup_wrapper')){
                $ass_popup.find('.popup_wrapper').hide();
            }
        })
        $('.fas.close').on('click', function(){
            $ass_popup.find('.popup_wrapper').hide();
        })
	}

	/**
	 * ================
	 * HANDLE EVENTS
	 * ================
	*/

	function handleShoeDecline(btn){
		if(btn.hasClass('locked')) return;
		const service_item = btn.parents('.service_item');
		service_item.toggleClass('not-calculate');
		calculateTotals();
	}
	function handleMandatoryBtnClick(){
		$('.popup_wrapper.assessment-mandatory').show();
	}

	function handleShoeRefund(checkbox, $assessment_popup){
		$assessment_popup.find(`.shoe-update-content.${checkbox.data('shoe')} .service_item`).toggleClass('not-calculate');
		calculateTotals();
	}

	function handlePopupSubmit(event, btn, $assessment_popup){
		event.preventDefault();
		const list_services = {
			order_id: current_order_id,
			add: [],
			remove: [],
			refund: []
		};

		/** collect services to add */
		$assessment_popup.find('.update-inner.add-items .service_item:not(.not-calculate)').each(function () {
			let services_to_add = {
				id: $(this).find('input[name="id"]').val(),
				price: $(this).find('input[name="price"]').val(),
				variant_title: $(this).find('input[name="variant_title"]').val(),
				shoes_number: $(this).find('input[name="shoes_number"]').val(),
				collection: $(this).find('input[name="collection"]').val(),
				type: $(this).find('input[name="type"]').val(),
				collection_number: $(this).find('input[name="collection_number"]').val(),
				product_name: $(this).find('input[name="product_name"]').val(),
				source: $(this).find('input[name="source"]').val(),
				odoo: $(this).find('input[name="odoo"]').val(),
			};
			list_services.add.push(services_to_add);
		});

		/** collect services to remove */
		$assessment_popup.find('.update-inner.remove-items .service_item:not(.not-calculate)').each(function () {
			let services_to_remove = {
				id: $(this).find('input[name="id"]').val(),
				price: $(this).find('input[name="price"]').val(),
				variant_title: $(this).find('input[name="variant_title"]').val(),
				shoes_number: $(this).find('input[name="shoes_number"]').val(),
				line_item: $(this).find('input[name="line_item_id"]').val(),
				source: $(this).find('input[name="source"]').val(),
				odoo: $(this).find('input[name="odoo"]').val(),
			};
			list_services.remove.push(services_to_remove);
		});
		/** collect services to refund */
		$assessment_popup.find('.update-inner.shoe-items .service_item:not(.not-calculate)').each(function () {
			let services_to_refund = {
				id: $(this).find('input[name="id"]').val(),
				price: $(this).find('input[name="price"]').val(),
				variant_title: $(this).find('input[name="variant_title"]').val(),
				shoes_number: $(this).find('input[name="shoes_number"]').val(),
				line_item: $(this).find('input[name="line_item_id"]').val(),
				source: $(this).find('input[name="source"]').val()
			};
			list_services.refund.push(services_to_refund);
		});
		btn.find('.spin').removeClass('hide');
		$.post(`${tracking_url}/updateorder.php`,
			JSON.stringify(list_services),
			function (response) {
				if (response.hasOwnProperty('additionalPaymentCollectionUrl')) {
					window.location.replace(response.additionalPaymentCollectionUrl);
				} else {
					btn.find('.spin').addClass('hide');
				}
			},  
			'json'
		).fail(function (error) {
			console.log("request failed");
			btn.find('.spin').addClass('hide');
		});
	}

	function cancelOrder(btn, order_id) {
		let data = {
			id: order_id,
			action: 'cancel_order'
		};
		btn.find('.spin').removeClass('hide')
		$.post(`${tracking_url}/storeFrontCalls.php`,
			JSON.stringify(data),
			function (resp) {
				alert('Order Canceled');
				window.location.replace(Shop_url); 
			},
			'json'
		).fail(function (error) {
			alert('failed to load order')
		});
	}

	async function afterUpdate(order) {
		if (!order.payment_needed || (order.payment_needed && order.paid)){
			alert('Order already updated');
			$('.placeholder-spin').addClass('hide');
			return;
		}
		if (order.payment_needed && !order.paid) {
			const metafields = await fetchMetafields(order.order_id);
			const paymeta = metafields.filter((meta) => (meta.key == 'paymentLink'));
			const container = $('#after-update-section');
			container.find('.payment-link').attr('href', paymeta[0].value);
			// container.find('button').on('click', function (e) {
			// 	e.preventDefault();
			// 	cancelOrder($(this), order.order_id);
			// });
			container.removeClass('hide');
			$('.placeholder-spin').addClass('hide');
		}
	}

	return {
		init,
		drawOrderUpdates,
		afterUpdate
	}
}